import {
  resetThread,
  toggleVoiceChatMode,
} from '@webclient/state/slices/search-session';
import { roomInstance } from '@webclient/state/slices/search-session/utils/room-manager';
import { stopDictation } from '@webclient/state/slices/search-widget-dictation';

import { createAsyncThunk } from '@reduxjs/toolkit';
import { ConnectionState, LivekitError } from 'livekit-client';

const disconnectFromRoom = createAsyncThunk(
  'searchSession/disconnectFromRoom',
  async (_, { rejectWithValue, dispatch }) => {
    const room = roomInstance.get();
    try {
      if (room && room.state !== ConnectionState.Disconnected) {
        const encoder = new TextEncoder();
        const encodedData = encoder.encode('{}');
        await room.localParticipant.publishData(encodedData, {
          reliable: true,
          topic: 'client_shut',
        });
        dispatch(stopDictation());
        await room.disconnect();
        dispatch(resetThread());
        dispatch(toggleVoiceChatMode(false));
      }
    } catch (error) {
      return rejectWithValue((error as LivekitError).message);
    }
  },
);

export default disconnectFromRoom;
